export class Provincia {
    id: number;
    nome: string;
    itemName: string;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/provincia.ts